import { render, staticRenderFns } from "./AudioDocument.vue?vue&type=template&id=d4f0d702&scoped=true&"
import script from "./AudioDocument.vue?vue&type=script&lang=js&"
export * from "./AudioDocument.vue?vue&type=script&lang=js&"
import style0 from "./AudioDocument.vue?vue&type=style&index=0&id=d4f0d702&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f0d702",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow,VSheet})
